var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.52V4C21.5 3.60218 21.342 3.22064 21.0607 2.93934C20.7794 2.65804 20.3978 2.5 20 2.5H2C1.60218 2.5 1.22064 2.65804 0.93934 2.93934C0.658035 3.22064 0.5 3.60218 0.5 4V16C0.5 16.3978 0.658035 16.7794 0.93934 17.0607C1.22064 17.342 1.60218 17.5 2 17.5H13.6",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5.5H0.5V8.5H21.5V5.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.5C21.2614 21.5 23.5 19.2614 23.5 16.5C23.5 13.7386 21.2614 11.5 18.5 11.5C15.7386 11.5 13.5 13.7386 13.5 16.5C13.5 19.2614 15.7386 21.5 18.5 21.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0117 14.7227L19.8203 15.4141H16.1641L16.3555 14.7227H20.0117ZM18.2422 19L16.2773 16.6836L16.2734 16.1016H17.207C17.4492 16.1016 17.6484 16.0586 17.8047 15.9727C17.9635 15.8841 18.082 15.7656 18.1602 15.6172C18.2383 15.4661 18.2773 15.2982 18.2773 15.1133C18.2773 14.9128 18.2409 14.7357 18.168 14.582C18.0951 14.4284 17.9792 14.3086 17.8203 14.2227C17.6615 14.1367 17.4518 14.0938 17.1914 14.0938H16.168L16.3789 13.3125H17.1914C17.6523 13.3125 18.0352 13.3815 18.3398 13.5195C18.6445 13.6576 18.8724 13.8581 19.0234 14.1211C19.1771 14.3841 19.2539 14.7018 19.2539 15.0742C19.2539 15.3997 19.1979 15.6875 19.0859 15.9375C18.974 16.1849 18.793 16.3854 18.543 16.5391C18.293 16.6901 17.9609 16.7839 17.5469 16.8203L19.3438 18.9492V19H18.2422ZM20.0156 13.3125L19.8203 14.0039H16.832L17.0234 13.3125H20.0156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.a02c828a8a6a2431a01e7e30bf5f641b.svg";
export { ForwardRef as ReactComponent };